export default {"src":"/_next/static/media/features-my-playlists.857d7d71.gif","height":300,"width":400};